import { Crown } from 'lucide-react';
import { Switch } from "@/components/ui/switch";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

interface PremiumToggleProps {
  lessonId: string;
  isPremium: boolean;
  onUpdate: () => void;
}

export const PremiumToggle = ({ lessonId, isPremium, onUpdate }: PremiumToggleProps) => {
  const handlePremiumToggle = async () => {
    try {
      console.log('Toggling premium status for lesson:', lessonId);
      
      const { error } = await supabase
        .from('lessons')
        .update({ is_premium: !isPremium })
        .eq('id', lessonId);

      if (error) {
        console.error('Error updating premium status:', error);
        throw error;
      }

      console.log('Premium status updated successfully');
      
      toast({
        title: "Estado actualizado",
        description: `Lección marcada como ${!isPremium ? 'premium' : 'gratuita'}`,
      });

      onUpdate();
    } catch (error) {
      console.error('Error toggling premium status:', error);
      toast({
        title: "Error",
        description: "No se pudo actualizar el estado premium",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Crown className={`h-4 w-4 ${isPremium ? 'text-amber-500' : 'text-gray-400'}`} />
      <Switch
        checked={isPremium}
        onCheckedChange={handlePremiumToggle}
        className="data-[state=checked]:bg-amber-500"
      />
    </div>
  );
};